import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"
import { obtener_formulario_omitiendo_imagenes_ya_guardadas } from "../../ayudas/funciones"


export default class solicitudImportarExcel extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);
        this.state = {
            registro: {},
            mostrarSpinner: false,
            colapsar: true
        };
        this.fileInput = React.createRef();
        this.actualizarArchivo = this.actualizarArchivo.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
    }

    actualizarArchivo = ({ target: { name, files } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: files[0] }
        }));
    }

    almacenarRegistro = async () => {        
        const { registro } = this.state;
        let datosFormulario = obtener_formulario_omitiendo_imagenes_ya_guardadas(registro, "img_nueva_solicitud", "img_calificacion", "img_solicitud_tarea_trabajada");
        datosFormulario.append("usuario", this.apiRest.getLS('du').id);

        this.setState({ mostrarSpinner: true });

        await this.apiRest.postFiles('/solicitudImportarExcel', datosFormulario).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Datos almacenados exitosamente!');
                this.setState({registro: {}});
                this.props.history.push("/dashboard")
            } else if (resultado.response.status === 400) {
                const errores = resultado.data.mensaje;
                const erroresFormateados = errores.map((error) => error.replace(/\n/g, '<br />'));
                toastr.error(erroresFormateados.join('<br />'));
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
            
            this.setState({ mostrarSpinner: false });
        });
        
    }

    Reporte = async () => {
        const auth = this.apiRest.getLS('authUser');
        if (auth !== null) {
            const headers = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                responseType: 'blob'
            }
            fetch(process.env.REACT_APP_API_URL + "/solicitudDescargarPlantilla", headers).then(resp => resp.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.style.display = "none";
                    a.href = url;
                    // the filename you want
                    a.download = "Plantilla.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
        } else {
            toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
        }
    }

    render() {
        const {
            mostrarSpinner,
            colapsar
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Solicitud" breadcrumbItem="Importar Excel" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Importar Excel</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="archivo_excel" className="form-label">
                                                                        Subir archivo
                                                                    </Label>
                                                                    <input
                                                                        name="archivo_excel"
                                                                        className="form-control"
                                                                        type="file"
                                                                        accept=".xls,.xlsx,.csv,.txt"
                                                                        onChange={this.actualizarArchivo}
                                                                        ref={this.fileInput}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={5}></Col>
                                                            <Col lg={3}>
                                                                <MDBBtn className="waves-effect"color="success" onClick={() => this.Reporte()} disabled={true}>
                                                                    <MDBIcon icon="fas fa-user-plus" />{' '}
                                                                    Descargar Plantilla
                                                                </MDBBtn>
                                                            </Col>
                                                        </Row>
                                                        <Col lg={12}>
                                                            <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/articuloListado') }}>
                                                                <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                                Regresar
                                                            </MDBBtn>
                                                            {' '}
                                                            {
                                                                mostrarSpinner ?
                                                                ''
                                                                :
                                                                <MDBBtn className="waves-effect" color="success" onClick={this.almacenarRegistro} disabled={true}>
                                                                    <MDBIcon icon="fas fa-user-check" /> {' '}
                                                                    Guardar
                                                                </MDBBtn>
                                                            }
                                                        </Col>
                                                    </div>
                                                </Form>
                                            </div>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>                        
                    </Container>
                </div>
                
                
            </React.Fragment>
        );
    }
}